import { createFileRoute } from "@tanstack/react-router";
import { BillDetail } from "../features/bill/bill-detail";
import { Require } from "../features/require";

/** A bill from More > Bills (P4-T20). */
export const Route = createFileRoute("/more/bills/$billId")({ component: Page });

function Page() {
	const { billId } = Route.useParams();
	return (
		<Require permission="bill.create">
			<BillDetail key={billId} billId={billId} />
		</Require>
	);
}
